<template>
<div class="box">
  <div class="address-detail-content" :style="{'padding-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
    <img src="static/img/收货地址空.png" class="default-empty" v-if=" addressInfo === undefined || addressInfo.length === 0">
    <div v-for="(address,index) in newAddressInfo" :id="index" style="width:100%;" >
      <div class="address-block">
        <div class="content" :id="'updateAddress' + index">
          <!--      <img v-if="parseInt(address.isDefault) === 1" src="static/img/默认flag.png" class="default-flag">-->
          <div class="item">
            <i class="icon-font emkt-icon-didian place"></i>
            <div class="mod" @click="updateAddress(address,index)">
              <div class="address" style="width:100%;">
                <div v-if="address.province !== ''">
<!--                <span v-if="address.district !== undefined">{{address.district}}</span>-->
                  {{address.expressAddress}}
                </div>
                <div v-else>
<!--                  {{address.city}}&nbsp;<span v-if="address.district !== undefined">{{address.district}}</span>-->
                  {{address.expressAddress}}
                </div>
                <div class="container">
                  {{address.consignee}}&nbsp;&nbsp;{{address.expressMobile}}
                </div>
              </div>
            </div>
            <router-link :to="{ name: 'WeappAddressModify', query: { address: JSON.stringify(address), from: from }, params:{order: $route.params.order, addressType: $route.params.addressType} }">
              <i class="icon-font emkt-icon-xiugai modify" style="color:#424242"></i>
            </router-link>
          </div>
        </div>
        <div v-if="address.addressSource===2 && !address.operator">
          <div>
            <hr style="border: 1px dashed; color: rgb(239, 239, 244); width: 100%; float: left; position: relative; top: 0px;"/>
          </div>
          <div class="appendInfo-layout">
            <div class="appendInfo-content">
              <div>创建业务员:{{address.creator}}</div><div>{{address.createDT}}</div>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
  <div class="footer">
    <div class="footer-content">
      <router-link :to="{name: 'WeappAddAddress', query: {from: from}, params:{order: $route.params.order, addressType: $route.params.addressType}}" style="width: 100%;">
        <div class="add-btn research-background-color"><span class="tag">+添加地址</span></div>
      </router-link>
    </div>
    <footer-placeholder></footer-placeholder>
  </div>
</div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import FooterPlaceholder from '../components/FooterPlaceholder'
  import EMKT from '../../emkt'

  export default {
    components: {FooterPlaceholder},
    created () {
      this.getData()
    },
    mounted () {
    },
    data () {
      return {
        addressInfo: [],
        from: ''
      }
    },
    computed: {
      ...mapState([
        'sessionInfo', 'weappMyOrders', 'chosenOrder'
      ]),
      'count': function () {
        return this.sessionInfo.expressAddress.length
      },
      newAddressInfo () {
        // let defaultAddress = this.addressInfo.filter(address => address.isDefault !== 0)
        // let restAddress = this.addressInfo.filter(address => address.isDefault === 0)
        // return defaultAddress ? [...defaultAddress, ...restAddress] : restAddress
        return this.addressInfo
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
        vm.from = from.query.from ? from.query.from : from.name
      })
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'EXPRESSADDRESS_UPDATE', 'UPDATE_WEAPP_MYORDERS'
      ]),
      getData () {
        let _this = this
        _this.gcapi('gcwwwifc/getAddressInfoByCustomerNo?customerNo=' + this.sessionInfo.customerInfo.customerNo).then((response) => {
          let result = response.body.result.filter(r => r.addressStatus !== EMKT.ADDRESS_STATUS.ADDRESS_STATUS_INVALID)
          _this.addressInfo = result
          _this.EXPRESSADDRESS_UPDATE(result)
        })
      },
      goBack () {
        console.log(this.$route.params.order)
        // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
        if (this.from === 'orderContentConfirm') {
          this.$router.replace({name: 'orderContentConfirm'})
        } else if (this.from === 'orderContent') {
          this.$router.replace({name: 'orderContent', params: {order: this.$route.params.order}})
        } else if (this.from === 'WeappOrderContentConfirmation') {
          this.$router.replace({name: 'WeappOrderContentConfirmation'})
        } else if (this.from === 'WeappOrderConfirmation') {
          this.$router.replace({name: 'WeappOrderConfirmation'})
        } else if (this.from === 'WeappMyOrderDetail') {
          this.$router.replace({name: 'WeappMyOrderDetail', params: {orderNo: this.$route.params.order.orderNo}})
        } else if (this.from === 'updateInvoiceTitle') {
          this.$router.replace({name: 'updateInvoiceTitle', params: {order: this.$route.params.order}})
        } else {
          this.$router.push({name: 'me'})
        }
      },
      updateAddress (address, index) {
        if (this.from === 'WeappOrderContentConfirmation' || this.from === 'WeappOrderConfirmation' || this.from === 'WeappMyOrderDetail' || this.from === 'updateInvoiceTitle') {
          this.changeColor(this.newAddressInfo)
          document.getElementById('updateAddress' + index).style.background = '#EFEEF3'
          let isDefault = 0
          if (this.from === 'WeappOrderContentConfirmation' || this.$route.params.addressType === 1) {
            if (address.isDefault === 2 || address.isDefault === 3) {
              isDefault = 3
            } else {
              isDefault = 1
            }
          } else if (this.from === 'updateInvoiceTitle' || this.from === 'WeappOrderConfirmation' || this.$route.params.addressType === 4) {
            if (address.isDefault === 1 || address.isDefault === 3) {
              isDefault = 3
            } else {
              isDefault = 2
            }
          }
          let _this = this
          _this.$weui.loading()
          let params = {}
          params.customerNo = this.sessionInfo.customerInfo.customerNo
          params.creator = this.sessionInfo.customerInfo.customerName
          params.operator = this.sessionInfo.customerInfo.customerName
          params.expressAddressGuid = address.expressAddressGuid
          params.isDefault = isDefault
          params.consignee = address.consignee
          params.expressMobile = address.expressMobile
          params.expressAddress = address.expressAddress
          params.province = address.province
          params.city = address.city
          params.district = address.district
          params.addressSource = EMKT.ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT
          _this.gcapi('createOrUpdateAddress', params).then((response) => {
            if (response.body.code === 0) {
              let addressType = _this.$route.params.addressType
              if (addressType) {
                let jsonString = JSON.stringify(_this.$route.params.order)
                let orderBo = JSON.parse(jsonString)
                orderBo.addressType = addressType
                if (addressType === 1) {
                  orderBo.expressAddress = address.province + address.city + address.district + address.expressAddress
                  orderBo.expressMobile = address.expressMobile
                  orderBo.expressName = address.consignee
                } else if (_this.$route.params.addressType === 4) {
                  orderBo.invoiceAddress = address.province + address.city + address.district + address.expressAddress
                  orderBo.invoiceMobile = address.expressMobile
                  orderBo.invoiceName = address.consignee
                }
                _this.updateOrderExpressAddressOrInvoiceAddress(orderBo)
              } else {
                _this.getData()
                _this.$weui.toast('修改成功', 1500)
                _this.$weui.loading().hide()
                _this.goBack()
                setTimeout(function () {
                }, 900)
              }
            }
            if (response.body.code === 1) {
              _this.$weui.topTips('出错')
              _this.$weui.loading().hide()
            }
          })
        }
      },
      updateOrderExpressAddressOrInvoiceAddress (order) {
        let _this = this
        _this.gcapi('updateOrderExpressAddressOrInvoiceAddress', order).then((response) => {
          if (response.body.code === 0) {
            _this.$route.params.order = order
            _this.getData()
            _this.$weui.toast('修改成功', 1500)
            _this.$weui.loading().hide()
            EMKT.setLocalStorage('addressOrder', order)
            _this.goBack()
            setTimeout(function () {
            }, 900)
          }
        })
      },
      changeColor (addressInfoList) {
        for (let i = 0; i < addressInfoList.length; i++) {
          document.getElementById('updateAddress' + i).style.background = '#ffffff'
        }
      }
    }
  }

</script>

<style scoped>
.box {
  overflow-y:scroll;
  overflow-x:hidden;
  height:100vh;
  position: relative;
  /* background-color: #EFEEF3; */
  padding: 10px;
  padding-bottom: 0;
  background-color: #fafafa;
}

.default-empty {
  width: 100%;
  height: 250px;
  margin-top: 35%;
}

.default-flag {
  width: 31px;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 31px;
}

 .modify {
  position: absolute;
  top: 25px;
  right: 20px;
  width: 17px;
  height: 19px;
  font-size: 20px;
 }

 .mod {
  display: flex;
  flex-flow: row wrap;
  /* align-content:center; */
  padding: 0px 11px;
  align-items: center;
}

 .address-block {
   display: flex;
   flex-direction: column;
   position: relative;
   justify-content: flex-start;
   opacity: 1;
   background-color: #ffffff;
   border-radius: 10px;
   width: 100%;
   margin-bottom: 10px;
   border:0.5px solid rgba(239, 238, 243, 1);
 }

.content {
  display: flex;
  position: relative;
  justify-content: space-around;
  opacity: 1;
  width: 100%;
  height: 80px;
}

.item {
  display: flex;
  width: 100%;
  padding-left: 14px;
}

.place {
  display: flex;
  align-items: center;
  margin-top: 32px;
  color: #5878FA;
  width: 12px;
  height: 17px;
}

.address{
  opacity: 1;
  display: flex;
  max-width: 250px;
  flex-flow: row wrap;
  align-content:flex-start;
  color: #424242;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  font-weight: bold;
}

.container {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  margin-top: 4px;
  width: 100%;
  height: 17px;
  color: #929292;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  white-space: nowrap;
}

.footer {
  position: fixed;
  bottom:0;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #fff;
}

.footer-content {
  display: flex;
  align-items: center;
  align-self: center;
  flex-direction: row;
  background-color: #ffffff;
  width: 100%;
  height: 58px;
  padding: 0px 10px;
}

.add-btn {
  width: 100%;
  height: 44px;
  border-radius: 44px;
  line-height: 20px;
  color: #fff;
  text-align: center;
}

.tag {
  color: #ffffff;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  position: absolute;
  margin-top: 12px;
  margin-left: -30px;
}
.appendInfo-layout {
  padding-left: 37px;
  padding-right: 20px;
  height: 27px;
}
.appendInfo-content {
  align-items: flex-end;
  height: 22px;
  color: #5878FA;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
}
</style>




// WEBPACK FOOTER //
// Address.vue?21aebc71